/**
 * Utilidades para manejo de usuarios y sus imágenes
 */

/**
 * Obtiene la URL del thumbnail del usuario basado en el campo agent_photo
 * @param {Object} userProfile - Perfil del usuario con agent_photo
 * @returns {string} URL del thumbnail o imagen por defecto
 */
export const getUserThumbnailUrl = (userProfile) => {
  if (!userProfile || !userProfile.agent_photo) {
    // Imagen por defecto si no hay agent_photo
    return '/images/users/thumbnails/default-avatar.jpg';
  }

  // Extraer el nombre del archivo de agent_photo
  // Puede venir como "path/to/image.jpg" o solo "image.jpg"
  const filename = userProfile.agent_photo.split('/').pop();
  
  // Construir la URL del thumbnail
  return `/images/users/thumbnails/${filename}`;
};

/**
 * Obtiene la URL del thumbnail del usuario desde el backend
 * @param {number} userId - ID del usuario
 * @returns {Promise<string>} URL del thumbnail
 */
export const fetchUserThumbnailUrl = async (userId) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || '/api';
    const response = await fetch(`${apiUrl}/users/${userId}/thumbnail`);
    if (response.ok) {
      const data = await response.json();
      return data.thumbnail_url;
    }
    return '/images/users/thumbnails/default-avatar.jpg';
  } catch (error) {
    console.error('Error fetching user thumbnail:', error);
    return '/images/users/thumbnails/default-avatar.jpg';
  }
};

/**
 * Obtiene las iniciales del usuario para mostrar como fallback
 * @param {Object} userProfile - Perfil del usuario
 * @returns {string} Iniciales del usuario
 */
export const getUserInitials = (userProfile) => {
  if (!userProfile) return 'U';
  
  if (userProfile.username) {
    const names = userProfile.username.split(' ');
    if (names.length >= 2) {
      return `${names[0][0]}${names[1][0]}`.toUpperCase();
    }
    return names[0][0].toUpperCase();
  }
  
  if (userProfile.email) {
    return userProfile.email[0].toUpperCase();
  }
  
  return 'U';
};

/**
 * Verifica si existe una imagen de thumbnail para el usuario
 * @param {string} thumbnailUrl - URL del thumbnail
 * @returns {Promise<boolean>} True si la imagen existe
 */
export const checkThumbnailExists = async (thumbnailUrl) => {
  try {
    const response = await fetch(thumbnailUrl, { method: 'HEAD' });
    return response.ok;
  } catch (error) {
    return false;
  }
};